module.exports = __webpack_public_path__ + "img/android-icon-72x72.f0c2b7a7.png";